import { useCallback, useEffect, useRef } from 'react';

const CHIME_SRC = '/assets/sounds/mailsball-chime.mp3';

/**
 * Preloads chime and tracks first user gesture (for autoplay policy).
 * @param {{ requireInteractionForPlay?: boolean }} options
 */
export default function useNotificationChime(options = {}) {
  const { requireInteractionForPlay = true } = options;
  const audioRef = useRef(null);
  const interactedRef = useRef(false);

  useEffect(() => {
    audioRef.current = new Audio(CHIME_SRC);
    audioRef.current.load();

    const enableSound = () => {
      if (!interactedRef.current) {
        interactedRef.current = true;
      }
    };

    document.addEventListener('click', enableSound);
    document.addEventListener('keydown', enableSound);

    return () => {
      document.removeEventListener('click', enableSound);
      document.removeEventListener('keydown', enableSound);
    };
  }, []);

  const playChime = useCallback(() => {
    const audio = audioRef.current;
    if (!audio) return;
    if (requireInteractionForPlay && !interactedRef.current) {
      return;
    }
    audio.currentTime = 0;
    audio.play().catch((err) => console.error('Notification chime play failed:', err));
  }, [requireInteractionForPlay]);

  return { playChime };
}
